'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherInfo, FeatherMessageCircle, FeatherScale, FeatherSend, FeatherUsers } from '@subframe/core';
import type { ReactNode } from 'react';
import { PRODUTOS } from '../constants';
import type { UseOnboardingSelfReturn } from '../hooks';
import type { ProdutoId } from '../types';
import { ProdutoCard } from './ProdutoCard';
import { WizardFooter } from './WizardFooter';
import { WizardHeader } from './WizardHeader';
interface ProdutosScreenProps {
  vm: UseOnboardingSelfReturn;
}
const ICONE_PRODUTO: Record<ProdutoId, ReactNode> = {
  notificacao: <FeatherSend className="text-brand-600" />,
  lexi: <FeatherMessageCircle className="text-brand-600" />,
  mediacao: <FeatherUsers className="text-brand-600" />,
  arbitragem: <FeatherScale className="text-brand-600" />
};
export const ProdutosScreen = t0 => {
  const $ = _c(29);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm.stepperSteps) {
    t1 = <WizardHeader steps={vm.stepperSteps} />;
    $[0] = vm.stepperSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-10 flex w-full max-w-[1280px] flex-col gap-2"><h1 className="text-heading-dark text-2xl leading-tight font-semibold sm:text-[32px]">O que você pretende usar na Arbitralis?</h1><p className="text-label-muted text-base leading-relaxed">Escolha ao menos um produto. Só liberamos a plataforma para quem vai operar nela — nada de conta vazia.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== vm) {
    t3 = PRODUTOS.map(produto => <ProdutoCard key={produto.id} produto={produto} icone={ICONE_PRODUTO[produto.id]} selecionado={vm.produtos.includes(produto.id)} onAlternar={() => vm.alternarProdutoSelecionado(produto.id)} />);
    $[3] = vm;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div role="group" aria-label="Produtos da Arbitralis" className="grid w-full max-w-[1280px] grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-[repeat(auto-fit,minmax(340px,1fr))]">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherInfo className="flex-none text-neutral-500" />;
    t6 = <span className="flex-1 text-[13px] text-neutral-600">Foi notificado por uma empresa e só quer responder? Você não precisa de conta.</span>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== vm.abrirAviso) {
    t7 = <div className="mt-6 flex w-full max-w-[1280px] flex-wrap items-center gap-2.5 rounded-[12px] border border-solid border-neutral-200 bg-neutral-50 px-4 py-3.5">{t5}{t6}<button type="button" onClick={vm.abrirAviso} className="text-brand-600 hover:text-brand-400 flex-none text-[13px] font-semibold underline transition-colors">Ir para o painel do notificado</button></div>;
    $[9] = vm.abrirAviso;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <div className="flex flex-1 flex-col items-center px-6 py-10 md:px-20 md:py-14">{t2}{t4}{t7}</div>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== vm) {
    t9 = () => vm.goTo("empresa");
    $[14] = vm;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== vm) {
    t10 = () => vm.goTo("operacao");
    $[16] = vm;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = !vm.podeAvancarProdutos;
  let t12;
  if ($[18] !== vm.produtosResumo) {
    t12 = <span aria-live="polite" className="text-[13px] text-neutral-500">{vm.produtosResumo}</span>;
    $[18] = vm.produtosResumo;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t9) {
    t13 = <WizardFooter voltarLabel="Voltar" onVoltar={t9} avancarLabel={"Confirmar e avan\xE7ar"} onAvancar={t10} avancarDisabled={t11} aoLadoDoAvancar={t12} />;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t1 || $[26] !== t13 || $[27] !== t8) {
    t14 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t8}{t13}</div>;
    $[25] = t1;
    $[26] = t13;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};